<template>
  <div class="content-item">
    <a-row class="mt-3" v-if="type !== 'welcome'">
      <a-col :span="24">
        <p v-html="$t('page.dashboardIndividual.introduction')" />
      </a-col>
    </a-row>

    <a-row class="mt-3 mb-3">
      <a-col :xs="{ span: 24, offset: 0 }" :md="{ span: 20, offset: 2 }" :xl="{ span: 16, offset: 4 }">
        <a-row :gutter="16">
          <a-col :xs="24" :md="8">
            <a-button type="primary" class="action-button tf-btn tf-btn-primary mt-2" @click.prevent="$emit('onSelectVideoType', 'record')">
              <inline-svg :src="require('../../assets/images/record-video.svg')" width="18" height="12" />
              <span style="margin-left: 8px">{{ $t('button.recordVideo') }}</span>
            </a-button>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-button type="primary" class="action-button tf-btn tf-btn-primary mt-2" @click.prevent="$emit('onSelectVideoType', 'file')">
              <inline-svg :src="require('../../assets/images/upload-file.svg')" width="18" height="12" />
              <span style="margin-left: 8px">{{ $t('button.uploadVideo') }}</span>
            </a-button>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-button type="primary" class="action-button tf-btn tf-btn-primary mt-2" @click.prevent="$emit('onSelectVideoType', 'embed')">
              <inline-svg :src="require('../../assets/images/embed-video.svg')" width="19" height="9" />
              <span style="margin-left: 8px">{{ $t('button.embedVideo') }}</span>
            </a-button>
          </a-col>
        </a-row>
        <!-- <a class="tf-text-primary text-underline" :href="'/resources/SYS_Worksheet.pdf'" download="story_guide.pdf">Download Story Guide</a> -->
        <!-- <img :src="require('../../assets/images/how_to_film.png')" /> -->
        <!-- <img src="resources/images/challenge-resource/film_like_this.png" alt="Truelife" /> -->
      </a-col>
    </a-row>

    <a-row>
      <a-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 16, offset: 4 }" :xl="{ span: 12, offset: 6 }">
        <div class="responsive-embed">
          <iframe :src="videoUrl" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </div>
      </a-col>
    </a-row>

    <a-row class="mt-5 text-left" v-if="isPastor" style="font-size: 26px">
      <a-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 18, offset: 3 }">
        <p>
          <strong v-text="'Example of what to say for your invitation video:'"></strong>
        </p>

        <p>
          You might be wondering why someone handed this to you (hold up your card), it’s because we love you and want you to come to our church. On Sunday we were praying that God would help us reach
          people in our community with these cards and now you’re looking at this video. I’m pastor at {{ churchName }} church and I want you to know that I love you, but more importantly, Jesus loves
          you. You might not realize it now, but God has a great plan for your life, because he didn’t just create you without a plan. So down below there are video answers that will help you find
          God's plan but again, even more importantly, there is an open invitation to our church where we will help you embrace God’s plan for your life.
        </p>
      </a-col>
    </a-row>

    <a-row class="mt-5 text-left" v-else-if="isIndividual">
      <a-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 18, offset: 3 }">
        <p style="font-size: 26px">
          <strong v-text="'Not sure where to start? Watch the video above and let us help you tell your Jesus Story.'"></strong>
        </p>

        <ul style="list-style-type: none; padding-left: 0">
          <li>
            <p>
              <strong>Short Option:</strong>
            </p>
            <p class="text-italic">We make it simple with this short option. Please practice this at least 10 times and then film. Feel free to make adjustments or say every word.</p>
            <p>
              Hi, I’m (name), and there was a point in time in my life when someone shared with me that Jesus loves me unconditionally, and I want to be that person for you! Below me, there are video
              answers to life’s hard questions and a link to my wonderful church!
            </p>
          </li>
          <li>
            <p>
              <br />
              <strong>Long Option:</strong>
            </p>
            <p class="text-italic">
              If you want to create a more custom Jesus story, it is simpler than you may imagine! Finish each statement below, and before you know, it you will have your testimony written out maybe
              for the first time!
            </p>
            <p style="line-height: 2">
              Before I knew Jesus I was…. <br />
              I understood I needed Jesus because… <br />
              Now that I know Jesus I am… <br />
              To me Jesus is…. <br />
              I want you to know Jesus, like I do because….. <br />
            </p>
            <p class="text-italic">
              You also can download and print the Jesus Story worksheet,
              <a-button
                type="link"
                class="text-italic"
                style="color: #ffb612 !important; padding: 0; font-style: initial; font-size: 18px"
                :href="'/resources/SYS_Worksheet.pdf'"
                download="story_guide.pdf"
                >Click Here</a-button
              >.
            </p>
          </li>
        </ul>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { includes } from 'lodash';
export default {
  props: {
    type: {
      type: String,
      default: 'welcome',
    },
  },
  data() {
    return {
      churchName: '',
    };
  },
  mounted() {
    const { user } = this.$store.state;
    this.churchName = user.user.churchName;
  },
  computed: {
    videoUrl() {
      const { user, settings } = this.$store.state;
      if (includes(user.user.role, 'individual')) {
        return settings.configVars.SHARE_STORY_INSTRUCTION_LINK;
      }
      return settings.configVars.WELCOME_INSTRUCTION_LINK;
    },
  },
};
</script>

<style lang="scss" scoped>
.action-button {
  width: 200px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
}
</style>
